import {
  Spin,
  Modal as ModalAntd,
} from "antd";
import { useParams } from "react-router-dom";
import React, {
  useEffect,
  useState,
  useCallback,
} from "react";
import {
  Contract,
  get,
} from "../../../../api";
import UpdatedFilesList from "./v2";
import FilesList from "./v1";

const ContractFilesList = () => {
  const { id } = useParams();
  const [contract, setContract] = useState<Contract | null>(null);
  const [loading, setLoading] = useState(true);

  const getContract = useCallback(async () => {
    if (!id) return;

    const httpContract = await get<Contract>(`/contracts/${id}`);
    if (httpContract.statusCode === 200) {
      setContract(httpContract.response);
    }
    setLoading(false);
  }, [id]);

  useEffect(() => {
    getContract();
  }, [getContract]);

  if (loading) {
    return <Spin tip="Cargando lista de archivos..." />;
  }

  if (!contract) {
    return null;
  }

  return <>{contract.ver == 1 ? <FilesList contract = {contract}/> : <UpdatedFilesList  contract = {contract}/>}</>;
};

export default ContractFilesList;
